import { render, staticRenderFns } from "./StudioForm.vue?vue&type=template&id=33cc5f3b&scoped=true&"
import script from "./StudioForm.vue?vue&type=script&lang=js&"
export * from "./StudioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc5f3b",
  null
  
)

export default component.exports